import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const ShipmentPlanningWizardRoute: RouteType = {
  name: "ShipmentPlanningWizard",
  path: "/workflows/shipment-planning",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Shipment Planning",
      component: () => import("./ShipmentPlanningWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./ShipmentPlanningWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for shipment planning
      const loadStore = rootStore.loadStore as ServiceStore;
      const trailerStore = rootStore.trailerStore as ServiceStore;
      const yardInventoryItemsStore = rootStore.yardInventoryItemsStore as ServiceStore;
      const yardLocationsStore = rootStore.yardLocationsStore as ServiceStore;
      const panelStore = rootStore.panelStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;
      const userStore = rootStore.userStore as ServiceStore;
      const salesOrdersStore = rootStore.salesOrdersStore as ServiceStore;

      await Promise.all([
        loadStore?.find(),
        trailerStore?.find(),
        yardInventoryItemsStore?.find(),
        yardLocationsStore?.find(),
        panelStore?.find(),
        productsStore?.find(),
        jobStore?.find(),
        userStore?.find(),
        salesOrdersStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for shipment planning:", error);
      return false;
    }
  },
};

export default ShipmentPlanningWizardRoute;